/* Magnifixcarp — comportements légers (sans dépendance) */
(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  };

  /* ---------- Barre « livraison offerte » ---------- */
  const shipBars = () => document.querySelectorAll('[data-mfx-ship]');

  const renderShip = (cart) => {
    shipBars().forEach((el) => {
      const threshold = Number(el.dataset.threshold || 0);
      if (!threshold) return;
      const currency = el.dataset.currency || cart.currency;
      const total = Number(cart.total_price || 0);
      const left = Math.max(0, threshold - total);
      const text = el.querySelector('[data-mfx-ship-text]');
      const bar = el.querySelector('[data-mfx-ship-bar]');
      if (text) {
        if (total === 0) {
          text.textContent = el.dataset.labelEmpty.replace('[montant]', money(threshold, currency));
        } else if (left > 0) {
          text.textContent = el.dataset.labelLeft.replace('[montant]', money(left, currency));
        } else {
          text.textContent = el.dataset.labelDone;
        }
      }
      if (bar) bar.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
    });
  };

  const refreshShip = () => {
    if (!shipBars().length) return;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then((r) => r.json())
      .then(renderShip)
      .catch(() => {});
  };

  ['shopify:cart:lines-update', 'cart:update', 'cart-drawer:update'].forEach((name) => {
    document.addEventListener(name, () => setTimeout(refreshShip, 600), true);
  });

  /* ---------- Article : sommaire, progression, barre produit ---------- */
  const slug = (text) =>
    text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 60);

  const initArticle = () => {
    const prose = document.querySelector('[data-mfx-prose]');
    if (!prose) return;

    const headings = [...prose.querySelectorAll('h2')];
    const used = new Set();
    headings.forEach((h) => {
      if (!h.id) {
        let id = slug(h.textContent) || 'partie';
        while (used.has(id)) id += '-2';
        h.id = id;
      }
      used.add(h.id);
    });

    document.querySelectorAll('[data-mfx-toc]').forEach((list) => {
      list.innerHTML = '';
      headings.forEach((h) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.dataset.tocLabel || h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
    });

    document.querySelectorAll('[data-mfx-toc-count]').forEach((el) => {
      el.textContent = headings.length;
    });

    if (!headings.length) {
      document.querySelectorAll('.mfx-toc, .mfx-toc-mobile').forEach((el) => (el.hidden = true));
    }

    const links = () => document.querySelectorAll('.mfx-toc a');
    if ('IntersectionObserver' in window && headings.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links().forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === '#' + entry.target.id));
          });
        },
        { rootMargin: '0px 0px -70% 0px' }
      );
      headings.forEach((h) => io.observe(h));
    }

    const bar = document.querySelector('[data-mfx-progress]');
    const sticky = document.querySelector('[data-mfx-sticky-product]');
    const onScroll = () => {
      const rect = prose.getBoundingClientRect();
      const total = rect.height - window.innerHeight * 0.5;
      const done = Math.min(1, Math.max(0, -rect.top / (total || 1)));
      if (bar) bar.style.width = done * 100 + '%';
      if (sticky) sticky.classList.toggle('is-visible', rect.top < -400 && rect.bottom > window.innerHeight);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* ---------- Guide « quelle recette » ---------- */
  const initFinder = () => {
    document.querySelectorAll('[data-mfx-finder]').forEach((form) => {
      const rulesEl = form.querySelector('script[type="application/json"]');
      const rules = rulesEl ? JSON.parse(rulesEl.textContent || '[]') : [];
      const out = form.querySelector('[data-mfx-finder-result]');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const eau = data.get('eau');
        const saison = data.get('saison');
        const pression = data.get('pression');
        const ok = (rule, key, value) => !rule[key] || rule[key] === 'toutes' || rule[key] === value;
        const match =
          rules.find((r) => ok(r, 'eau', eau) && ok(r, 'saison', saison) && ok(r, 'pression', pression)) || rules[0];
        if (!match || !out) return;
        out.querySelector('[data-mfx-finder-name]').textContent = match.name;
        out.querySelector('[data-mfx-finder-why]').textContent = match.why || '';
        const link = out.querySelector('[data-mfx-finder-link]');
        link.href = match.url;
        out.classList.add('is-visible');
        link.focus({ preventScroll: true });
      });
    });
  };

  const init = () => {
    refreshShip();
    initArticle();
    initFinder();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
